import { render } from "./ControlButtons.vue?vue&type=template&id=f41a48ee&scoped=true"
import script from "./ControlButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./ControlButtons.vue?vue&type=script&setup=true&lang=js"

import "./ControlButtons.vue?vue&type=style&index=0&id=f41a48ee&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f41a48ee"],['__file',"src/pages/scada/forms/ControlButtons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f41a48ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f41a48ee', __exports__)) {
    console.log('reload')
    api.reload('f41a48ee', __exports__)
  }
  
  module.hot.accept("./ControlButtons.vue?vue&type=template&id=f41a48ee&scoped=true", () => {
    console.log('re-render')
    api.rerender('f41a48ee', render)
  })

}


export default __exports__